import React from 'react';
import styles from './PrivateKeyStorageModal.module.css';
import { CheckboxCircleIcon } from 'assets/icons';

const SuccessfullActionModal = ({ message }) => {
    return (
        <div className={`${styles.action_status} ${styles.status_success}`}>
            <CheckboxCircleIcon color={"#139c1c"} size={60} />
            <span>{message ? message : "Action successful!"}</span>
        </div>
    )
}

export default SuccessfullActionModal;